import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';

import Layout from "../components/UI/Layout/Layout";
import BillsToReceive from "../components/BillsToReceive/BillsToReceiveList";
import BillsForm from "../components/BillsToReceive/BillsForm";
import * as billsToReceiveActions from "~/components/BillsToReceive/actions";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";
import { LocalCacheHandler } from '~/utils/local-cache-handler';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import usePersistedFilters from '~/_shared/hooks/usePersistedFilters';
import {
  EXTRAS_FILTERS_KEY,
  getDefaultExtrasFilters,
  getExtrasRequest,
  isExtrasPeriodDefault,
} from "~/components/BillsToReceive/filters";

export const ScreensBillsToReceive = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const isFirstLoad = useRef(true);

  // Filters kept across refreshes for a few minutes (per tenant/user/page).
  const persisted = usePersistedFilters(EXTRAS_FILTERS_KEY, getDefaultExtrasFilters);
  const applied = persisted.filters;

  // Loads the restored (or default) period on mount, and again when it changes.
  useEffect(() => {
    loadData();
  }, [applied.from, applied.to]);

  async function loadData() {
    const firstLoad = isFirstLoad.current;
    isFirstLoad.current = false;
    // The IndexedDB cache is keyed by route only, so it only ever holds the
    // default period; using it for another period would flash wrong data.
    const usesCache = isExtrasPeriodDefault(applied, persisted.defaults);

    try {
      if (firstLoad && usesCache) {
        await LocalCacheHandler.load({
          actionName: CACHE_ACTIONS.customerExtras,
          dispatch,
          pathname
        });
      }
      const request = getExtrasRequest(applied);
      // First load keeps the top bar only (as before); later changes use the default loader.
      if (firstLoad) request.showLoading = false;
      const { payload } = await dispatch(billsToReceiveActions.loadExtras(request));
      if (usesCache) {
        await LocalCacheHandler.save({
          pathname,
          data: payload.data.data
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <BillsToReceive persisted={persisted} />
        <BillsForm />
      </Layout>
    </div>
  );
};
